import React from "react";
import { TabsContainer, Tab } from "./Tabs.styles";

export interface TabItem<TTabId extends string> {
  id: TTabId;
  label: React.ReactNode;
  icon?: React.ReactNode;
  disabled?: boolean;
}

export interface TabsProps<TTabId extends string> {
  activeTab: TTabId;
  onTabChange: (tabId: TTabId) => void;
  tabs: TabItem<TTabId>[];
  className?: string;
  ariaLabel?: string;
}

export const Tabs = <TTabId extends string>({
  activeTab,
  onTabChange,
  tabs,
  className,
  ariaLabel,
}: TabsProps<TTabId>) => {
  return (
    <TabsContainer className={className} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          active={activeTab === tab.id}
          onClick={() => !tab.disabled && onTabChange(tab.id)}
          disabled={tab.disabled}
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </Tab>
      ))}
    </TabsContainer>
  );
};
